export default function Schedule(id, userId, clss) {
    this.id = id;
    this.userId = userId;
    this.clss = clss;
}